<input type="hidden" id="anPageName" name="page" value="login-1"style="overflow: hidden;" />
<div class="box login_container">
	<div class="row header">
		<div class="col-12">
			<img class="image-1" src="../assets/newimg/image-13-1@2x.png " alt="CBRTA " />
		</div>
	</div>
	<div class="row" >
		<div class="col-lg-8 col-sm-6 container-login-text">
			<div class="overlayimage">
				<p class="surname opensans-bold-white-41px">
					<span class="opensans-normal-white-41px">Cross</span>
					<span class="ellipsis"></span>
					<span class="opensans-extra-extra-bold-white-41px">Easy</span>
				</p>
				
				<div class="here">
					<span class="opensans-normal-white-16px">Here, There, Everywhere</span>
				</div>
				<h1 class="banner_text_wrap">
					<p>Convenient, Effective</p>
					<p>and Secure way to apply</p>
					<p>and manage your</p>
					<p>Permits Online</p>
				</h1>
			</div>
		</div>

			<div class="col-lg-4 col-sm-6 form-container">
			<div class="form_inner_wrapper">
				<h2><span class="opensans-bold-black-32px">Login</span></h2>
				<p class="opensans-normal-black-16px form_subheading">Please complete the fields below to login</p>
				<div class="form_field">
					<label class="label">Email</label>
					<div class="input-text">
						<input type="text" [ngClass]="{
				'input-error':
				  emailref.errors && (emailref.touched || emailref.dirty)
			  }" placeholder="Enter email" [(ngModel)]="loginUser.UserName" class="form-field input-text" #emailref="ngModel" (keyup)="checkEmail($event.target.value)"
							required />
						<div *ngIf="emailref.errors && (emailref.touched || emailref.dirty)" class="error_message">
							Email is required
						</div>
					</div>
				</div>
				<div class="form_field">
					<label class="label">Password</label>
					<div class="input-text passR">
						<i class="fa fa-eye-slash" *ngIf="hide == false" id="input_img" (click)="showPassword()"
							aria-hidden="true"></i>
						<i class="fa fa-eye" style="margin-left: -50%" *ngIf="loginUser.Password && hide == true"
							(click)="showPassword()" id="input_img" aria-hidden="true"></i>
						<input [type]="hide ? 'password' : 'text'" [ngClass]="{
				'input-error':
				  password.errors && (password.touched || password.dirty)
			  }" placeholder="Enter password" [(ngModel)]="loginUser.Password" class="form-field input-text" #password="ngModel"
							required />

						<div *ngIf="password.errors && (password.touched || password.dirty)" class="error_message">
							Password is required
						</div>
					</div>
				</div>
				<div class="overlap-group d-none">
					<div class="input-group">
						<div class="row input">
							<div class="base">
								<div class="email">
									<span class="">Email</span>
								</div>
								<div class="frame-4">
									<div class="form-field">
										<div class="frame-3">
											<div class="input-text">
												<input type="text" placeholder="Enter email"
													[(ngModel)]="loginUser.UserName" class="form-field input-text"
													style="color: white" #emailref="ngModel" required />
												<div *ngIf="
                            emailref.errors &&
                            (emailref.touched || emailref.dirty)
                          " class="error_message">
													Email is required
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row input-1">
							<div class="base">
								<div class="email">
									<span class="">Password</span>
								</div>
								<div class="frame-4">
									<div class="form-field">
										<div class="frame-3-1">
											<div class="input-text-1">
												<i class="fa fa-eye-slash" *ngIf="hide == false" id="input_img"
													(click)="showPassword()" aria-hidden="true"></i>
												<i class="fa fa-eye" *ngIf="loginUser.Password && hide == true"
													(click)="showPassword()" id="input_img" aria-hidden="true"></i>
												<input [type]="hide ? 'password' : 'text'" placeholder="Enter password"
													[(ngModel)]="loginUser.Password" class="form-field input-text"
													#password="ngModel" required />

												<div *ngIf="
                            password.errors &&
                            (password.touched || password.dirty)
                          " class="error_message">
													Password is required
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="link-button">
							<div class="forgot-password opensans-semi-bold-white-12px">
								<a class="txt-pass pull-right" (click)="forgot()">
									<span class="opensans-semi-bold-white-12px" style="cursor:pointer">Forgot
										Password?</span></a>
							</div>
						</div>
						<div class="statedefault">
							<p class="please-complete-the opensans-normal-black-16px">
								<span class="opensans-normal-black-16px">Please complete the fields below to
									login</span>
							</p>
							<div class="flex-row" *ngIf="isCBRTAEmail == false">
								<div class="recaptcha_container" *ngIf="showCaptcha">
									<re-captcha class="g-recaptcha" data-size="normal" (resolved)="resolved($event)"
										siteKey="{{ getSiteKey() }}">
									</re-captcha>
								</div>
							</div>
						</div>
						<!-- <div class="primary">
                            <div class="login-3 opensans-semi-bold-black-16px"> -->

						<div class="row" style="margin-top: 32px">
							<div class="col-sm-12 text-center">
								<!-- <div class="col-sm-6">
                                    <button id="btnlogin" class="btn btn-primary btn-md" (click)="login() ">Login</button>
                                </div>
                                <div class="col-sm-6">
                                    <button id="btnregister" class="btn btn-danger btn-md" (click)="regiser() ">Register</button>
                                </div> -->
								<form>
									<div class="row">
										<div class="col-6">
											<!-- <input type="text" class="form-control" placeholder="First name"> -->
											<!-- <button type="button" class="form-control btn btn-primary">Primary</button> -->
											<button id="btnlogin" class="btn btn-warning btn-lg form-control hd-btn"
												(click)="login()">
												Login
											</button>
										</div>
										<div class="col-6" style="margin: left 20px">
											<!-- <input type="text" class="form-control" placeholder="First name"> -->
											<!-- <button type="button" class="form-control btn btn-primary">Primary</button> -->
											<button id="btnregister"
												class="btn btn-outline-warning btn-lg form-control hd-btn"
												(click)="regiser()">
												Register
											</button>
										</div>
									</div>
								</form>

								<!-- <button id="btnlogin" class="btn primary btn-lg" (click)="login() ">Login</button>
                                <button id="btnregister" class="btn btn-outline-warning btn-lg" (click)="regiser() ">Register</button> -->
							</div>
						</div>
						<!-- </div>
                        </div> -->
					</div>
					
					<div class="overlap-group-2">
						<!-- <img class="line-1 " src="../assets/newimg/line-1-1@2x.png " alt="Line 1 " />
                        <div class="or-1 opensans-semi-bold-white-16px ">
                            <span class="opensans-semi-bold-white-16px ">or</span>
                        </div> -->
						<div class="separator opensans-semi-bold-white-16px">OR</div>
					</div>
					<div class="overlap-group-container">
						<div class="facebook-container">
							<!-- <img class="icon-facebook " src="../assets/newimg/facebook-1-1@2x.png " alt="icon-facebook " />
                            <div class="facebook opensans-semi-bold-black-16px ">
                                <span class="opensans-semi-bold-black-16px ">Facebook</span>
                            </div> -->
							<button (click)="socialSignIn('facebook')"
								class="btn hd-btn loginBtn--facebook btn-facebook">
								<img class="icon-facebook" src="../assets/newimg/facebook-1-1@2x.png "
									alt="icon-facebook " />
								Login with Facebook
							</button>
						</div>
					</div>

					<p class="click-here-to-access opensans-bold-sunglow-16px">
						<span class="opensans-bold-sunglow-16px">Click
							<a href="https://www.cbrta.co.za/permits/permit-portal" target="_blank">here</a>
							to access the CrossEasy User Manual.</span>
					</p>
				</div>
				<div class="form_field">
					<div class="forgot-password">
						<a class="opensans-semi-bold-black-12px txt-pass" (click)="forgot()">
							Forgot Password?</a>
					</div>
				</div>
				<div class="flex_row" *ngIf="isCBRTAEmail == false">
					<div class="recaptcha_container" *ngIf="showCaptcha && environment != 'qa'">
						<re-captcha class="g-recaptcha" data-size="normal" (resolved)="resolved($event)"
							siteKey="{{ getSiteKey() }}">
						</re-captcha>
					</div>
				</div>
				<div class="btn-group-flex">
					<!-- Login Button -->
					<div class="btn-col">
						<button id="btnlogin" class="btn btn-warning btn-lg form-control hd-btn" (click)="login()">
							Login
						</button>
					</div>
					<!-- Register Button -->
					<div class="btn-col">
						<button id="btnregister" class="btn btn-outline-warning btn-lg form-control hd-btn"
							(click)="regiser()">
							Register
						</button>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="horizontal_separator">
							<span>OR</span>
						</div>
					</div>
				</div>
				<div class="btn-group-flex">
					<div class="btn-col">
						<button id="facebookLogin" class="btn btn-lg form-control text-left"
							(click)="socialSignIn('facebook')">
							<img class="icon-facebook" src="../assets/newimg/facebook-1-1@2x.png " height="20"
								alt="Login with Facebook" />
							<span>Facebook</span>
						</button>
					</div>
					<div class="btn-col">
						<button id="googleLogin" class="btn btn-lg form-control" #loginRef>
							<img class="icon-facebook" src="../assets/newimg/search-1-2@2x.png " height="20"
								alt="Login with Google" />
							<span>Google</span>
						</button>
					</div>
				</div>
			</div>
			<div class="row">
				<span class="col-12 opensans-bold-black-16px link">
					<a href="https://www.cbrta.co.za/permits/permit-portal" target="_blank" class="link">Click here to
						access the CrossEasy User Manual.</a>
				</span>
			</div>
		</div>
	</div>
</div>

<div class="d-none"></div>